import { Loader2 } from 'lucide-react'
import { cn } from '../../lib/cn'

/** Verdigris-when-on pill switch. `busy` shows an inline spinner and locks the control. */
export function Switch({
  on,
  onClick,
  busy,
  disabled,
  label,
}: {
  on: boolean
  onClick: () => void
  busy?: boolean
  disabled?: boolean
  label?: string
}) {
  return (
    <button
      type="button"
      role="switch"
      aria-checked={on}
      aria-label={label}
      disabled={disabled || busy}
      onClick={onClick}
      className={cn(
        'relative inline-flex h-[22px] w-[38px] shrink-0 items-center rounded-full transition-colors disabled:cursor-not-allowed',
        on ? 'bg-verdigris' : 'bg-line',
        (disabled || busy) && 'opacity-60',
      )}
    >
      <span
        className={cn(
          'inline-flex h-[16px] w-[16px] items-center justify-center rounded-full bg-white shadow transition-transform',
          on ? 'translate-x-[19px]' : 'translate-x-[3px]',
        )}
      >
        {busy && <Loader2 className="h-[10px] w-[10px] animate-spin text-muted" />}
      </span>
    </button>
  )
}

/** Active / inactive status chip. */
export function StateChip({ on }: { on: boolean }) {
  return (
    <span
      className={cn(
        'inline-flex items-center gap-1.5 rounded-full px-2.5 py-[3px] text-[11.5px] font-bold',
        on ? 'bg-ok-soft text-ok' : 'bg-line-soft text-muted',
      )}
    >
      <span className={cn('h-[7px] w-[7px] rounded-full', on ? 'bg-ok' : 'bg-faint')} />
      {on ? 'Attivo' : 'Disattivo'}
    </span>
  )
}

/** Dashboard-style stat tile (matches RatesPage). */
export function Stat({ label, value, sub }: { label: string; value: string; sub?: string }) {
  return (
    <div className="cv-panel px-4 py-3.5">
      <div className="text-[11px] font-bold uppercase tracking-[1.4px] text-muted">{label}</div>
      <div className="mt-1 font-display text-[24px] font-bold leading-none tracking-[-.5px] text-coal">{value}</div>
      {sub && <div className="mt-1 text-[12px] text-muted">{sub}</div>}
    </div>
  )
}
